var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6994 6.30001C14.5161 6.48694 14.4135 6.73826 14.4135 7.00001C14.4135 7.26176 14.5161 7.51308 14.6994 7.70001L16.2994 9.30001C16.4863 9.48324 16.7376 9.58587 16.9994 9.58587C17.2611 9.58587 17.5124 9.48324 17.6994 9.30001L21.4694 5.53001C21.9722 6.6412 22.1245 7.87924 21.9058 9.07916C21.6872 10.2791 21.1081 11.3839 20.2456 12.2463C19.3832 13.1087 18.2784 13.6878 17.0785 13.9065C15.8786 14.1251 14.6406 13.9728 13.5294 13.47L6.61937 20.38C6.22154 20.7778 5.68198 21.0013 5.11937 21.0013C4.55676 21.0013 4.01719 20.7778 3.61937 20.38C3.22154 19.9822 2.99805 19.4426 2.99805 18.88C2.99805 18.3174 3.22154 17.7778 3.61937 17.38L10.5294 10.47C10.0265 9.35882 9.87428 8.12078 10.0929 6.92087C10.3115 5.72095 10.8907 4.61617 11.7531 3.75373C12.6155 2.8913 13.7203 2.31218 14.9202 2.09355C16.1201 1.87493 17.3582 2.02718 18.4694 2.53001L14.7094 6.29001L14.6994 6.30001Z",
    stroke: "#203FAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.3226a58cf7cb374dc9367a4a0eb3c5a8.svg";
export { ForwardRef as ReactComponent };